define(
    'viewmodels/secured/explorer/navigation/favourites/favourites',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "viewmodels/secured/explorer/navigation/menu",
        "services/service.documents",
        "services/service.folders",
        "providers/dataprovider",
        "services/BusyTracker",
        "i19n!i19n/strings"
    ],
    function(ctx, ViewModel, menu, documentsService, foldersService, dataProvider, BusyTracker, i19n) {
        var pressTimer = null;
        var __tmp = null;

        var vm = new ViewModel(
        {
            i19n: i19n,
            menu: menu,
            favouritesMenuItem: new menu.Item(true, 'favourite'),

            folders: ko.observableArray([]),
            foldersLoaded: ko.observable(false),

            searches: ko.observableArray([]),
            searchesLoaded: ko.observable(false),

            documentsLinkActive: ko.observable(false),
            activeFolder: ko.observable(),
            activeSearch: ko.observable()
        });

        vm.activeFolder.subscribe(function (folder) {
            unselectAllFolders();

            if (folder != null)
                folder.isSelected(true);
        });
        vm.activeSearch.subscribe(function (search) {
            unselectAllSearches();

            if (search != null)
                search.isSelected(true);
        });

        vm.menu.items().push(vm.favouritesMenuItem);
 
        vm.activate = function () {
        };
        vm.attached = function () {            
        };

        vm.documentsLinkIsBusy = ko.computed(function() {
           return vm.favouritesMenuItem.isSelected() && vm.documentsLinkActive() && documentsService.busyTracker.isBusy();
        });
        vm.showDocumentsLink = ko.computed(function () {
            return vm.favouritesMenuItem.isSelected() && vm.foldersLoaded();
        });
        vm.showFolderLinks = ko.computed(function () {
            return vm.favouritesMenuItem.isSelected() && vm.foldersLoaded() && vm.folders().length;
        });
        vm.showNoFoldersMessage = ko.computed(function () {
            return vm.favouritesMenuItem.isSelected() && vm.foldersLoaded() && !vm.folders().length;
        });
        vm.showSearchLinks = ko.computed(function () {
            return vm.favouritesMenuItem.isSelected() && vm.searchesLoaded() && vm.searches().length;
        });
        vm.showNoSearchesMessage = ko.computed(function () {
            return vm.favouritesMenuItem.isSelected() && vm.searchesLoaded() && !vm.searches().length;
        });

        // overriding the default menu isBusy() computed.
        vm.favouritesMenuItem.isBusy = ko.computed(function () {
            return vm.favouritesMenuItem.isSelected() && foldersService.busyTracker.isBusy();
        });
        vm.favouritesMenuItem.isSelected.subscribe(function (newValue) {
            ctx.onNavFolder(null);

            // if unselected reset the folders[] - forcing a reload before sliding down the menu.
            if (!newValue) {
                vm.folders([]);
                vm.foldersLoaded(false);
                vm.activeFolder(null);

                vm.searches([]);
                vm.searchesLoaded(false);

                //ctx.onNavFolder(null);
            } else {
                _loadFolders();

                _loadSearch();
            }
        });

        vm.renameFolderAction = ko.asyncCommand({
            canExecute: function () {
                return vm.activeFolder() != null;
            },
            execute: function (complete) {
                vm.activeFolder().isBeingRenamed(true);

                complete();

                $(".active-folder-text").val(vm.activeFolder().label());

                $(".active-folder-text").unbind("keyup");
                $(".active-folder-text").keyup(function (e) {
                    if (e.keyCode == 27) {
                        vm.activeFolder().isBeingRenamed(false);
                    }
                });
                $(".active-folder-text").unbind("keypress");
                $(".active-folder-text").keypress(function (e) {
                    if (e.which == 13) {
                        var newLabel = $(this).val();
                        var oldLabel = vm.activeFolder().label();

                        if (newLabel == "" || oldLabel == newLabel) {
                            vm.activeFolder().isBeingRenamed(false);

                            return;
                        }

                        foldersService
                        .favouriteFolder(vm.activeFolder().folderId, newLabel)
                        .done(function () { })
                        .always(function (folders) {
                            vm.activeFolder().label(newLabel);
                            vm.activeFolder().isBeingRenamed(false);

                            var f = ctx.findFolder({ folderId: vm.activeFolder().folderId, libraryId: vm.activeFolder().libraryId });
                            if (f)
                                f.name(newLabel);
                        });
                    }
                });
            }
        });
        vm.renameSearchAction = ko.asyncCommand({
            canExecute: function () {
                return vm.activeSearch() != null;
            },
            execute: function (complete) {
                vm.activeSearch().isBeingRenamed(true);

                complete();

                $(".active-search-text").val(vm.activeSearch().label());

                $(".active-search-text").unbind("keyup");
                $(".active-search-text").keyup(function (e) {
                    if (e.keyCode == 27) {
                        vm.activeSearch().isBeingRenamed(false);
                    }
                });
                $(".active-search-text").unbind("keypress");
                $(".active-search-text").keypress(function (e) {
                    if (e.which == 13) {
                        var newLabel = $(this).val();
                        var oldLabel = vm.activeSearch().label();

                        if (newLabel == "" || oldLabel == newLabel) {
                            vm.activeSearch().isBeingRenamed(false);

                            return;
                        }

                        vm.activeSearch().q.savedSearchName = newLabel;
                        vm.activeSearch().q.id = vm.activeSearch().q.savedSearchId;
                        vm.activeSearch().query = _toQueryString(vm.activeSearch().q);

                        dataProvider.search
                        .renameSearchMetadata(vm.activeSearch().q)
                        .done(function () { })
                        .always(function (folders) {
                            vm.activeSearch().label(newLabel);
                            vm.activeSearch().isBeingRenamed(false);
                        });
                    }
                });

            }
        });

        vm.showFavouriteDocumentsAction = ko.asyncCommand({
            canExecute: function () {
                return vm.favouritesMenuItem.isSelected();
            },
            execute: function (complete) {
                if (__tmp) {
                    __tmp.isBeingRenamed(false);
                }
                vm.activeFolder(null);
                vm.documentsLinkActive(true);

                ctx.onNavFavoriteDocument(null);

                complete();
            }
        });
        vm.showFavouriteFolderAction = function (folder, event) {
            if (__tmp) {
                __tmp.isBeingRenamed(false);
            }
            // when clicking in the rename textbox, this event is firing. we need to prevent the load of documents again if renaming a file.
            if (vm.activeFolder() === folder && folder.isBeingRenamed())
                return;
            
            folder.removeFolder.subscribe(function (p) {
                if (p.toggle)
                    _unfavoriteFolder({ folderId: p.folderId, libraryId: p.libraryId });
                else
                    _favoriteFolder({ folderId: p.folderId, libraryId: p.libraryId });

                function _favoriteFolder(f) {
                    //check state if folder has been loaded
                    var f2 = ctx.findFolder(f);
                    
                    if (f2) {
                        f2.isFavourite(true);
                    }

                    setTimeout(function () {
                        //vm.favouritesMenuItem.isSelected(true);
                        _loadFolders()
                        .done(function () {
                            var f3 = _.findWhere(vm.folders(), { folderId: f.folderId });

                            if (f3)
                                f3.isSelected(true);
                        });
                    }, 1000);
                    
                }
                function _unfavoriteFolder(f) {
                    //check state if folder has been loaded
                    //var f = _.findWhere(vm.folders(), { folderId: folderId });

                    //if (f) {
                        var f2 = ctx.findFolder(f);

                        if (f2) {
                            f2.isFavourite(false);
                        }
                    //}

                    //now remove from favourite menu
                    var folders = _.reject(vm.folders(), function (itm) { return itm.folderId == f.folderId; });

                    vm.folders(folders);
                }
            });

            vm.activeFolder(folder);
            vm.activeSearch(null);
            vm.documentsLinkActive(false);            
            
            ctx.onNavFavoriteFolder(folder);
        };
        vm.showFavouriteSearchAction = function (search, event) {
            if (__tmp) {
                __tmp.isBeingRenamed(false);
            }
            // when clicking in the rename textbox, this event is firing. we need to prevent the load of documents again if renaming a file.
            if (vm.activeSearch() === search && search.isBeingRenamed())
                return;

            search.removeSearch.subscribe(function (p) {
                if (p.toggle)
                    _unfavoriteSearch({ savedSearchId: p.savedSearchId });

                function _unfavoriteSearch(f) {
                    var searches = _.reject(vm.searches(), function (itm) { return itm.savedSearchId == f.savedSearchId; });

                    vm.searches(searches);
                }
            });

            vm.activeFolder(null);
            vm.activeSearch(search);
            vm.documentsLinkActive(false);
            
            ctx.onNavFavoriteSearch(search);
        };

        //vm.folderNameChanged = function (folder) {
        //    foldersService
        //    .favouriteFolder(folder.folderId, folder.label())
        //    .done(function() {})
        //    .always(function (folders) {
        //        folder.isBeingRenamed(false);
        //    });
        //};
       
        return vm;
        
        function _loadSearch() {
            return dataProvider.search
            .getSearchMetadata()
            .done(function (searches) {
                searches = _.sortBy(searches, function (itm) {
                    if (itm.savedSearchName.length > 0) {
                        itm.savedSearchName = itm.savedSearchName.substr(0).toUpperCase();
                    }

                    return itm.savedSearchName;
                });
                
                searches = _.map(searches, function (itm) {
                    var search = { q: itm };

                    search.savedSearchId = search.q.savedSearchId;
                    search.savedSearchName = ko.observable(search.q.savedSearchName);
                    search.label = ko.observable(search.savedSearchName());
                    search.path = ko.observable("");
                    search.isSelected = ko.observable(false);
                    search.isFavourite = ko.observable(true);
                    search.removeSearch = ko.observable(null);
                    search.isBeingRenamed = ko.observable(false);
                    search.searchLinkIsBusy = ko.computed(function () {
                        return vm.favouritesMenuItem.isSelected() && search.isSelected() && documentsService.busyTracker.isBusy();
                    });
                    search.label.subscribeChanged(function (newLabel, oldLabel) {
                        if (newLabel == "" || newLabel == null)
                            search.label(oldLabel);
                    });                    
                    search.query = _toQueryString(itm);
                    
                    return search;
                });

                

                vm.searches(searches);
                vm.searchesLoaded(true);

                _.map(searches, function (search) {
                    if (search.savedSearchId) {
                        var $search = $("#gp-fav-search-id-" + search.savedSearchId);

                        $search.off("mouseup", "**");
                        $search.on("mouseup", function () {

                            clearTimeout(pressTimer);

                            return false;
                        });

                        $search.off("mousedown", "**");
                        $search.on("mousedown", function () {
                            pressTimer = window.setTimeout(function () {
                                __tmp = search;
                                search.isBeingRenamed(true);

                                var $input = $("#gp-fav-search-input-id-" + search.savedSearchId);

                                $input.val(search.label());

                                $input.unbind("keyup");
                                $input.keyup(function (e) {
                                    if (e.keyCode == 27) {
                                        search.isBeingRenamed(false);
                                    }
                                });
                                $input.unbind("keypress");
                                $input.keypress(function (e) {
                                    if (e.which == 13) {
                                        var newLabel = $(this).val();
                                        var oldLabel = search.label();

                                        if (newLabel == "" || oldLabel == newLabel) {
                                            search.isBeingRenamed(false);

                                            return;
                                        }

                                        search.q.savedSearchName = newLabel;
                                        search.q.id = search.q.savedSearchId;
                                        search.query = _toQueryString(search.q);

                                        dataProvider.search
                                        .renameSearchMetadata(search.q)
                                        .done(function () { })
                                        .always(function (folders) {
                                            search.label(newLabel);
                                            search.isBeingRenamed(false);
                                        });
                                    }
                                });
                            }, 1500);

                            return false;
                        });
                    }
                });
            })
            .fail(function (e) {
                console.error(e);
            });
        }
        function _loadFolders() {
            return foldersService
            .getFavouriteFolders()
            .done(function (folders) {
                
                folders = _.map(folders, function (folder) {
                    folder.folderId = folder.folderId;
                    folder.name = ko.observable(folder.name);
                    folder.label = ko.observable(folder.label || folder.name);
                    folder.path = ko.computed(function () {
                        var path = String.format("<i class='fa fa-book'></i> {0}", folder.libraryName);
                        if (folder.listValueDescription) {
                            path += String.format(" / {0}" + folder.listValueDescription);
                        }
                        if (folder.label() != folder.name()) {
                            path += String.format(" / <i class='fa fa-folder-open-o'></i> {0} ", folder.name());
                        }
                        return path;
                    });
                    folder.isSelected = ko.observable(false);
                    folder.isFavourite = ko.observable(true);
                    folder.removeFolder = ko.observable(null);
                    folder.isBeingRenamed = ko.observable(false);
                    folder.folderLinkIsBusy = ko.computed(function () {
                        return vm.favouritesMenuItem.isSelected() && folder.isSelected() && documentsService.busyTracker.isBusy();
                    });
                    folder.label.subscribeChanged(function (newLabel, oldLabel) {
                        if (newLabel == "" || newLabel == null)
                            folder.label(oldLabel);
                    });

                    return folder;
                });

                folders = _.sortBy(folders, 'label');

                vm.folders(folders);
                vm.foldersLoaded(true);

                _.map(folders, function (folder) {
                    if (folder.folderId) {
                        var $folder = $("#gp-fav-folder-id-" + folder.folderId);

                        $folder.off("mouseup", "**");
                        $folder.on("mouseup", function () {

                            clearTimeout(pressTimer);

                            return false;
                        });

                        $folder.off("mousedown", "**");
                        $folder.on("mousedown", function () {
                            pressTimer = window.setTimeout(function () {
                                __tmp = folder;
                                folder.isBeingRenamed(true);

                                var $input = $("#gp-fav-folder-input-id-" + folder.folderId);

                                $input.val(folder.label());

                                $input.unbind("keyup");
                                $input.keyup(function (e) {
                                    if (e.keyCode == 27) {
                                        folder.isBeingRenamed(false);
                                    }
                                });
                                $input.unbind("keypress");
                                $input.keypress(function (e) {
                                    if (e.which == 13) {
                                        var newLabel = $(this).val();
                                        var oldLabel = folder.label();

                                        if (newLabel == "" || oldLabel == newLabel) {
                                            folder.isBeingRenamed(false);

                                            return;
                                        }

                                        foldersService
                                        .favouriteFolder(folder.folderId, newLabel)
                                        .done(function () { })
                                        .always(function (folders) {
                                            folder.label(newLabel);
                                            folder.isBeingRenamed(false);

                                            var f = ctx.findFolder({ folderId: folder.folderId, libraryId: folder.libraryId });
                                            if (f)
                                                f.name(newLabel);
                                        });
                                    }
                                });
                            }, 1500);

                            return false;
                        });
                    }
                });

            });
        }
        function unselectAllFolders() {
            _.each(vm.folders(), function (folder) {
                folder.isSelected(false);
            });
        }
        function unselectAllSearches() {
            _.each(vm.searches(), function (search) {
                search.isSelected(false);
            });
        }
        function _toQueryString(fields) {
            var documentFields = "?";

            for (var name in fields) {
                var value = fields[name];

                if (name == "savedSearchName")
                    value = encodeURI(value);

                if (value != null && value != "") {
                    if (value.constructor === Array) {
                        for (var i = 0; i < value.length; i++) {
                            documentFields = documentFields + name + '=' + value[i] + '&';
                        }
                    } else {
                        documentFields = documentFields + name + '=' + value + '&';
                    }
                }
            }

            return documentFields;
        }
    });
